<template>
  <div>
    <el-form-item label="IFSC" prop="card_type">
      <el-input
        v-model.trim="form.card_type"
        placeholder="请输入 IFSC"
        maxlength="22"
        clearable
        show-word-limit
      ></el-input>
    </el-form-item>
    <el-form-item label="Account Number" prop="card_no">
      <el-input v-model.trim="form.card_no" placeholder="请输入" maxlength="64" clearable show-word-limit></el-input>
    </el-form-item>
    <el-form-item label="Account Name" prop="real_name">
      <el-input v-model.trim="form.real_name" placeholder="请输入" maxlength="64" clearable show-word-limit></el-input>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'BankAccountFormFieldsIn',
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
}
</script>
